type Props = {
  code: string;
};

export default function DeepLinkCodeBadge({ code }: Props) {
  return (
    <div className="promo-code-badge" aria-label={`Код активации ${code}`}>
      {code}
    </div>
  );
}

function extractBareCode(value: string): string {
  if (value.includes(':')) {
    return value.slice(value.lastIndexOf(':') + 1);
  }
  if (value.includes('_')) {
    return value.slice(value.lastIndexOf('_') + 1);
  }
  return value;
}

export function resolveDeepLinkDisplayCode(
  startParam?: string | null,
  deepLinkCode?: string | null
): string | null {
  if (startParam?.trim()) {
    return extractBareCode(startParam.trim());
  }
  if (deepLinkCode?.trim()) {
    return extractBareCode(deepLinkCode.trim());
  }
  return null;
}
